import {TerminalSettingsResponse, getWithAuth} from '@/api'

export * from './models'

export const getTerminalSettings = (terminalId: string) =>
    getWithAuth<TerminalSettingsResponse>(`/oppapi/payments/settings/terminals/${terminalId}`)
